import classNames from 'classnames'

import styles from './DotMarker.module.scss'
export interface DotMarkerProps {
  size?: number
}
const DotMarker = ({ size }: DotMarkerProps) => {
  return <div style={{ width: size, height: size }} className={classNames(styles.pin_dot)} />
}

export default DotMarker
